// gray-matter (used by the blog markdown loader, src/blog) references the Node
// `Buffer` global, which Vite does not polyfill for the browser by default.
// Import this module FIRST in the entrypoint so Buffer exists before any blog
// module evaluates its eager `import.meta.glob` markdown parsing.
import { Buffer } from 'buffer';

const g = globalThis as unknown as { Buffer?: typeof Buffer };
if (typeof g.Buffer === 'undefined') {
  g.Buffer = Buffer;
}
